import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-950 text-slate-300 mt-24 relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img
              src="https://customer-assets-7cd3h4nn.emergentagent.net/job_wealth-academy-46/artifacts/x15oz6g3_Peak%20Market%20Society%20Logo.png"
              alt="Peak Market Society"
              className="w-11 h-11 rounded-full object-contain bg-white ring-1 ring-white/10"
            />
            <div>
              <div className="font-display font-black text-white tracking-tight text-lg leading-none">
                Peak Market Society
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-amber-500 font-semibold mt-1">
                {t("nav.tagline")}
              </div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-md">
            {t("footer.description")}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-amber-500 mb-4">{t("footer.learn")}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/courses" className="hover:text-white">{t("nav.courses")}</a></li>
            <li><a href="/articles" className="hover:text-white">{t("nav.articles")}</a></li>
            <li><a href="/pricing" className="hover:text-white">{t("nav.pricing")}</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-amber-500 mb-4">{t("footer.company")}</div>
          <ul className="space-y-2 text-sm">
            <li><span className="hover:text-white cursor-pointer">{t("footer.about")}</span></li>
            <li><span className="hover:text-white cursor-pointer">{t("footer.contact")}</span></li>
            <li><a href="/terms" data-testid="footer-terms-link" className="hover:text-white">{t("footer.terms")}</a></li>
            <li><a href="/privacy" data-testid="footer-privacy-link" className="hover:text-white">{t("onboarding.register.privacy")}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 text-xs text-slate-500">
          <span>{t("footer.legal", { year })}</span>
        </div>
      </div>
    </footer>
  );
}
